export const estPayant = (plugin) => {
  if (plugin.payant !== undefined) return plugin.payant;
  return /\bpro\b|\bpremium\b/i.test(plugin.name);
};
